import React, { useState, useEffect, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import ProjectListLoader from "../atoms/ProjectListLoader";
import { useNavigate } from "react-router-dom";
import Bid from "../organisms/BidTable";
import Button from "../atoms/Button";
import { getTransactionDetails } from "../../utils/API/getTransactionDetails";
import toast from "react-hot-toast";
import { getWalletBalance } from "../../utils/API/getWalletBalance";
import AcceptPopUp from "../molecules/AcceptPopUp";
import { orderPayment } from "../../utils/API/orderPayment";
import { LoadingOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import RetireDailogBox from "../molecules/RetireDailogBox";
import Input from "../atoms/Input";
import { applyCouponCode } from "../../utils/API/applyCouponCode";
import { taxationAmount } from "../../utils/API/taxationAmount";
// import { getAllRegistries } from "../../utils/API/getAllRegistries";

const OrderSummary = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const bidId = searchParams.get("bidId");
  const [transactionId, setTransactionId] = useState(null);
  const [walletBalance, setWalletBalance] = useState();
  const [projectData, setProjectData] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [bidData, setBidData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [notEnoughMoneyOpen, setNotEnoughMoneyOpen] = useState(false);
  const [confirmPayment, setConfirmPayment] = useState(false);
  const [payViaWallet, setPayViaWallet] = useState(false);
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [retireDailogBoxOpen, setRetireDialogBoxOpen] = useState(false);
  const [retireAcceptOpen, setRetireAcceptOpen] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [amount, setAmount] = useState(0);
  const [couponApplied, setCouponApplied] = useState(false);
  const [disCountApplied, setDisCountApplied] = useState(false);
  const [discountedValue, setDiscountedValue] = useState(0);
  const [remittance, setRemittance] = useState(0);
  const [gst, setGst] = useState(0);
  const [platformFee, setPlatformFee] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amountBeforeCoupon, setAmountBeforeCoupon] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [registriesName, setRegistriesName] = useState([]);
  const [currentRegistryName, setCurrentRegistryName] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const newTransactionId = searchParams.get("transactionId");
    setTransactionId(newTransactionId);
    if (newTransactionId) {
      setErrorMsg(null);
    }
  }, [searchParams]);

  useEffect(() => {
    if (transactionId) {
      fetchData();
      // fetchRegistries();
      fetchWalletBalance();
    }
  }, [transactionId]);

  useEffect(() => {
    if (bidData) {
      fetchTaxationData(bidData);
    }
  }, [bidData, disCountApplied]);

  // const fetchRegistries = async () => {
  //   try {
  //     const response = await getAllRegistries(); // await the async function

  //     // Extract registry names from the response
  //     const names = response.map((registry) => registry.registryName);

  //     // Update state with the array of names
  //     setRegistriesName(names);
  //   } catch (error) {
  //     toast.error("Failed to fetch registries: " + error.message); // Log detailed error message
  //   }
  // };

  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await getTransactionDetails(transactionId, dispatch);

      const projectDetails = data.data.projectDetails[0];
      setCurrentRegistryName(
        projectDetails.project.registryDetails.registryName
      );
      const bidDetails = data.data.bidDetails;

      setBidData({
        ...bidDetails,
        numberOfCredits: bidDetails.number_Of_Credits,
        bidAmount: bidDetails.bidAmount,
      });

      setProjectData({
        ...projectDetails,
        projectName: projectDetails.project.projectName,
        projectImages: projectDetails.project.cover_image,
        registryImage: projectDetails.project.registryDetails.registryImage,
        country: projectDetails.project.location.country,
        state: projectDetails.project.location.state,
        listedCredits: projectDetails.no_of_credits_to_sell,
        totalCredit: projectDetails.numberOfCredits,
        typeOfCredit: projectDetails.credit_transaction,
        OGscore: projectDetails.project.ogScore,
        categoryName: projectDetails.project.categoryDetails.categoryName,
        pricePerCredit: projectDetails.price_per_credit,
        tokenType: projectDetails.project.tokenType,
        projectId: projectDetails.project._id,
        typeOfCredit: projectDetails.project.typeOfCredit,
      });
    } catch (error) {
      setErrorMsg(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchWalletBalance = async () => {
    try {
      const balance = await getWalletBalance(dispatch);
      setWalletBalance(balance.data);
    } catch (error) {
      toast.error("Error in Fetching Wallet Balance");
    }
  };

  const fetchTaxationData = async (bidData) => {
    try {
      setCouponApplied(true);
      if (bidData) {
        const formData = {
          buyerOrigin: "NAT",
          sellerOrigin: "NAT",
          totalAmount: bidData.numberOfCredits * bidData.bidAmount,
        };
        const amounts = await taxationAmount(formData, dispatch);
        setAmount(formData.totalAmount);
        setGst(amounts.data.data.tax);
        setPlatformFee(amounts.data.data.platform_fee);
        setRemittance(amounts.data.data.remittance);
        const calculatedTotalAmount =
          formData.totalAmount +
          amounts.data.data.tax +
          amounts.data.data.platform_fee +
          amounts.data.data.remittance;

        if (!disCountApplied) {
          setAmountBeforeCoupon(calculatedTotalAmount);
          setTotalAmount(calculatedTotalAmount);
        } else {
          setTotalAmount(discountedValue + remittance);
        }
      }
    } catch (error) {
      toast.error("Error in Fetching Taxes and amounts Balance");
    } finally {
      setCouponApplied(false);
    }
  };

  const fetchpayment = async () => {
    try {
      setPaymentLoader(true);

      let reqCouponCode = disCountApplied ? couponCode : "";
      const payment = await orderPayment({
        transactionId,
        formData: { couponCode: reqCouponCode, retirementData: {} },
        dispatch,
      });
      if (payment) {
        setConfirmPayment(true);
        toast.success("Payment Done Successfully");
      }
    } catch (err) {
      if (err.message) {
        toast.error(err.message);
      } else {
        toast.error("Error while doing payments");
      }
    } finally {
      setPaymentLoader(false);
    }
  };

  const handlePayment = () => {
    // Check if the currentRegistryName exists in the registriesName array
    // if (registriesName.includes(currentRegistryName)) {
    //   // If present, fetch payment
    //   toast.success("Registry Found")
    //   // fetchpayment();
    // }

    const finalAmount = totalAmount;
    if (walletBalance >= finalAmount) {
      if (projectData?.typeOfCredit === "non-transferable") {
        setSelectedRowData({
          "Project Name": projectData.projectName,
          "Project Id": projectData.projectId,
          Category: projectData.categoryName,
          "Number Of Credits": bidData.numberOfCredits,
          "Token Type": projectData.tokenType,
        });
        setRetireDialogBoxOpen(true);
      }

      if (projectData?.typeOfCredit === "transferable") {
        // console.log("All Registries Name", registriesName);
        // console.log("Current Registry Name", currentRegistryName);
        if (currentRegistryName === "Others") {
          setSelectedRowData({
            "Project Name": projectData.projectName,
            "Project Id": projectData.projectId,
            Category: projectData.categoryName,
            "Number Of Credits": bidData.numberOfCredits,
            "Token Type": projectData.tokenType,
          });
          setRetireDialogBoxOpen(true);
        } else {
          fetchpayment();
        }
      }
    } else {
      setNotEnoughMoneyOpen(true);
    }
  };

  const handleGoToWallet = () => {
    navigate("/wallet");
  };

  const handleWalletSelect = () => {
    setPayViaWallet((prevState) => !prevState);
  };

  const handleRetireDialogOk = () => {
    setRetireDialogBoxOpen(false);
    setConfirmPayment(true);
  };

  const handleRetireAcceptOk = () => {
    setRetireAcceptOpen(false);
    navigate("/retirements");
  };

  const handleApplyCoupon = async () => {
    if (couponCode !== "") {
      const formData = {
        coupon_code: couponCode,
        gst,
        amount,
        platformfee: platformFee,
      };
      try {
        // console.log(couponCode);
        const response = await applyCouponCode(formData, dispatch);
        setDiscountedValue(response.coupon);
        setDisCountApplied(true);
      } catch (error) {
        toast.error("Not a valid Coupon Code");
      }
    } else {
      toast.error("Please Enter a Coupon Code first");
    }
  };

  return (
    <>
      {errorMsg !== null ? (
        <p className="text-center mt-64 text-3xl px-80 font-semibold text-blue-800">
          {errorMsg}
          <p className="flex justify-center text-xs font-light text-blue-600 mt-2">
            Can't pay now
          </p>
        </p>
      ) : (
        <div className="bg-[#F4F6FA] w-full h-full p-6">
          <div className="text-[1.5rem] font-medium tracking-widest">
            Order Summary
          </div>
          <div className=" flex justify-between w-full gap-5 pl-6 py-6">
            <div className="w-4/5 bg-white rounded-2xl  overflow-y-scroll no-scrollbar">
              <h1 className="ml-12 my-3 text-[28px] font-bold">Order</h1>
              {loading ? (
                <ProjectListLoader numberOfSkeletons={1} />
              ) : (
                <div className="px-5 mr-3">
                  <div className="flex flex-row justify-between bg-white shadow-md rounded-2xl h-32 w-full mb-5">
                    <div className="flex justify-start">
                      <div className="ml-1 my-1 relative w-48">
                        <img
                          src={projectData?.projectImages}
                          alt="Project Image"
                          style={{
                            width: "20rem",
                            height: "100%",
                            objectFit: "cover",
                          }}
                          className=""
                        />
                        {projectData?.tokenType === "Gold" && (
                          <div className="absolute bottom-0  left-0  bg-white rounded-tr-lg">
                            <img
                              src="images/goldToken.png"
                              alt="token Image"
                              className="w-8 h-8 text-[7px]"
                            />
                          </div>
                        )}
                      </div>

                      <div className="ml-4 p-2 flex flex-col justify-between">
                        <div className="flex flex-row ">
                          <h1 className="w-fit text-2xl shrink-0 font-black mt-2">
                            {projectData?.projectName}
                          </h1>
                          <div
                            className="w-14 h-12 ml-2 bg-no-repeat"
                            style={{
                              backgroundPosition: "top",

                              backgroundPosition: "center",
                              backgroundSize: "contain",
                              backgroundRepeat: "no-repeat",
                            }}
                          >
                            <img
                              className="w-full h-full mt-1"
                              src={projectData?.registryImage}
                              alt={"registry"}
                            />
                          </div>
                        </div>
                        <h2 className="text-sm h-fit w-fit">{`${projectData?.state}, ${projectData?.country}`}</h2>
                        <div className="text-sm">
                          <h3>
                            <span className="font-bold">
                              Listed Credits - {projectData?.listedCredits} |
                            </span>
                            <span className="font-medium">
                              {" "}
                              Total Credits - {projectData?.totalCredit} |
                            </span>

                            <span className=" capitalize">
                              {" "}
                              {projectData?.typeOfCredit}
                            </span>
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="pt-2 pr-4 flex flex-col items-end">
                      <div className="text-blue-200 text-right">
                        <div className="flex justify-end gap-3">
                          <h1 className="text-sm lg:font-light text-blue-800 ">
                            {projectData?.categoryName}
                          </h1>
                        </div>
                        <h2 className="text-sm font-bold mt-1 text-blue-800">
                          OG Score - {projectData?.OGscore}
                        </h2>
                      </div>
                      <h3 className="text-xl mt-1 font-medium text-right flex items-center">
                        $ {bidData?.bidAmount} per Credits
                      </h3>
                    </div>
                  </div>
                </div>
              )}
              <div>
                <Bid
                  location={`${projectData?.project?.location?.state}, ${projectData?.project?.location?.country}`}
                  bidPrice={`${bidData?.bidAmount}`}
                  isRequreIncreseDecreaseButton={true}
                  numberOfCredits={bidData?.numberOfCredits}
                  orderPayments={true}
                  amount={amount}
                  gst={gst}
                  platformFee={platformFee}
                  remittance={remittance}
                  totalAmount={totalAmount}
                  disCountApplied={disCountApplied}
                />
              </div>
              {disCountApplied && (
                <h3 className=" flex justify-end mr-20 text-lg text-red-500 pb-5">
                  Discount Amount : ${" "}
                  {amountBeforeCoupon - discountedValue - remittance}
                </h3>
              )}
            </div>
            <div className=" w-1/5 bg-white rounded-2xl">
              <h1 className=" pt-8 pb-4 text-xl text-center font-bold">
                Payment Methods
              </h1>
              {/* <div className=" mx-auto w-52  h-24 border-2 rounded-3xl mb-4">
                <div className="text-center text-base font-bold py-2">
                  Payment Gateway
                </div>
              </div> */}
              <div
                className={`mx-auto w-52 h-24 rounded-3xl border ${
                  payViaWallet ? "border-blue-800 border-4" : "border-2"
                }`}
                onClick={handleWalletSelect}
              >
                <div className="text-center text-base font-bold py-2">
                  Pay Via Wallet
                </div>
                <div className="text-center text-xs pt-2">Wallet Balance</div>
                <div className="text-center text-blue-600 font-semibold">
                  $ {walletBalance?.toFixed(2)}
                </div>
              </div>
              <div className="px-6 py-5">
                <div className="text-sm font-normal text-gray-500 ">
                  Coupon Code
                </div>
                <div className="flex justify-between w-full">
                  <Input
                    type="text"
                    variant="primary"
                    className="w-32"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                  <Button
                    varient={"secondary"}
                    className={`text-white py-1 px-3 text-xs ${
                      disCountApplied ? "bg-green-500" : "bg-blue-800"
                    }`}
                    onClick={handleApplyCoupon}
                    disabled={couponApplied}
                  >
                    {disCountApplied ? (
                      "Applied"
                    ) : couponApplied ? (
                      <LoadingOutlined />
                    ) : (
                      "Apply"
                    )}
                  </Button>
                </div>
                <p className="text-[10px] py-3 text-red-500 font-light">
                  Applied Coupon code will be applicable only for Platform fee{" "}
                </p>
              </div>
              <div className="flex pt-4 justify-center relative group">
                <Button
                  className={
                    "w-52 text-white h-9 bg-blue-800 rounded-lg text-lg font-bold"
                  }
                  onClick={handlePayment}
                  disabled={!payViaWallet || paymentLoader}
                >
                  {paymentLoader ? (
                    <div className="flex items-center ml-4 justify-center gap-2">
                      <span className="ml-2">Pay</span>
                      <div>
                        <LoadingOutlined className="ml-2" />
                      </div>
                    </div>
                  ) : (
                    "Pay"
                  )}
                </Button>
                {!payViaWallet && (
                  <div className="absolute invisible group-hover:visible w-62 h-16 bg-white opacity-80 left-[-45px] text-blue-800 rounded-md top-0 mt-[-40px] text-xs font-medium text-center pt-2">
                    First Select The Payment Method!
                    <p className="text-[9px] text-red-400">
                      After that, By clicking this button, the amount will be
                      automatically deducted from your account
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <RetireDailogBox
        open={retireDailogBoxOpen}
        onCancel={() => setRetireDialogBoxOpen(false)}
        onOk={handleRetireDialogOk}
        couponCode={disCountApplied ? couponCode : ""}
        payment={true}
        selectedRowData={selectedRowData}
        selectedColumns={["Project Name", "Number Of Credits", "Token Type"]}
        transactionId={transactionId}
      />

      <AcceptPopUp
        open={retireAcceptOpen}
        onCancel={() => setRetireAcceptOpen(false)}
        onOk={handleRetireAcceptOk}
        notOk={() => setRetireAcceptOpen(false)}
        isRequiredColor="green"
        title="Credit Retirement Request Initiated!!!"
        statusType="Retirement"
        okButtonText="Go to Retirement"
        cancelButtonText="Go Back"
      />

      <AcceptPopUp
        open={notEnoughMoneyOpen}
        onCancel={() => setNotEnoughMoneyOpen(false)}
        onOk={handleGoToWallet}
        title="Not Enough Money!"
        okButtonText="Go to Wallet"
        statusType={
          <span className="text-xs">
            You did not have enough Money to buy these credits !! Please go to
            wallet to <span className="font-bold"> add more money </span>
          </span>
        }
        isRequiredColor="red"
        isRequiredCancelButton={false}
        width={400}
      />

      <AcceptPopUp
        open={confirmPayment}
        onOk={() => navigate("/wallet")}
        notOk={() => navigate("/")}
        title="Order Confirmed!!"
        statusType={
          <span className="text-xs">
            Payment Successfully deducted from your wallet you can see the
            orders & your current balance in the{" "}
            <span className="font-bold">Wallet</span>
          </span>
        }
        okButtonText="Go to Wallet"
        cancelButtonText={"Go To Home"}
        isRequiredColor="green"
        width={400}
      />
    </>
  );
};

export default OrderSummary;
